'use es6';

import freeze from './helpers/freeze';
import { Promise } from './helpers/promise';

var promisifyMiddleware = function promisifyMiddleware(mw, options) {
  return Promise.resolve(mw(freeze(Object.assign({}, options, {
    _input: options
  }))));
};

export var createStack = function createStack() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  var first = fns[0],
      rest = fns.slice(1);
  return function (options) {
    if (rest.length === 0) {
      return promisifyMiddleware(first, options);
    }

    return rest.reduce(function (composed, current) {
      return composed.then(current);
    }, promisifyMiddleware(first, options));
  };
};